import { CategoryFacade } from "../category/category.facade";
import { JobStatusApiFacade } from "./job-status.api-facade";
import { JobStatusStoreFacade } from "./job-status.store-facade";
import { JobStatus } from "./job-status.model";

export class JobStatusFacade extends CategoryFacade<JobStatus, JobStatusApiFacade, JobStatusStoreFacade> {

}



// WEBPACK FOOTER //
// ./src/vas/business-objects/job-status/job-status.facade.ts